var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLossRunScan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19V5L6.14038 5.91803L7.31227 5L8.48415 5.91803L9.65603 5L10.8281 5.91803L12 5L13.1719 5.91803L14.344 5L15.5158 5.91803L16.6877 5L17.8596 5.91803L19 5V19H5ZM7.26471 15.3135H16.7353V14.1947H7.26471V15.3135ZM7.26471 12.5594H16.7353V11.4406H7.26471V12.5594ZM7.26471 9.80534H16.7353V8.68648H7.26471V9.80534ZM6.23529 17.296H17.7647V6.70403H6.23529V17.296Z",
    fill: "#A50DFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14.5C19 16.9853 16.9853 19 14.5 19C12.0147 19 10 16.9853 10 14.5C10 12.0147 12.0147 10 14.5 10C16.9853 10 19 12.0147 19 14.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14H17V15H12V14Z",
    fill: "#A50DFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.5V3.5H3.5V7H2.5V2.5H7Z",
    fill: "#A50DFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21.5V20.5H3.5V17H2.5V21.5H7Z",
    fill: "#A50DFD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.5V3.5H20.5V7H21.5V2.5H17Z",
    fill: "#A50DFD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.5V20.5H20.5V17H21.5V21.5H17Z",
    fill: "#A50DFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLossRunScan);
export default __webpack_public_path__ + "static/media/LossRunScan.8a758c1332e6de576d836f7a9498aa37.svg";
export { ForwardRef as ReactComponent };